import { useRef, useState } from "react";
import { FaTimes, FaDownload } from "react-icons/fa";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { API_BASE_URL } from "../../../../config";

const CustomerUploadModal = ({ onClose, onUploadSuccess }) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file || !file.name.endsWith(".csv")) {
      toast.error("Please select a valid .csv file");
      setSelectedFile(null);
    } else {
      setSelectedFile(file);
    }
  };

  const handleSubmit = async () => {
    if (!selectedFile) {
      toast.error("No file selected");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    const token = localStorage.getItem("token");

    const loadingToastId = toast.loading("Please wait... uploading file");

    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/customer/bulk-upload-customers`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );

      toast.dismiss(loadingToastId);
      toast.success(res.data.message || "File uploaded successfully");
      onClose();
      if (onUploadSuccess) onUploadSuccess();
    } catch (err) {
      toast.dismiss(loadingToastId);
      // console.error("Upload error:", err);
      toast.error(
        err.response?.data?.message || "Something went wrong during upload"
      );
    }
  };

  const downloadTemplate = () => {
    const headers = [
      "Lead Date",
      "Lead From",
      "Customer Name",
      "Customer Number",
      "Customer Address",
      "Required Flat Type",
      "Location Required",
      "Required Property  Type",
      "Budget",
      "Feedback Category",
      "Callback Date Time", 
      "Visit Schedule Date Time", 
      "Other Feedback Text", 
      "Followup Date",
      "Call Type",
      "Parking",
      "Client Feedback",
    ];

    const csvContent = [headers.join(",")].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "customer_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
        <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-navy-800">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
              Upload Customer CSV
            </h2>
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-red-600"
            >
              <FaTimes />
            </button>
          </div>

          <div className="mt-4 space-y-4">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept=".csv"
              className="w-full rounded border px-4 py-2 text-sm text-gray-700 dark:bg-navy-700 dark:text-white"
            />

            <button
              onClick={downloadTemplate}
              className="flex items-center gap-2 rounded bg-green-600 px-3 py-2 text-white hover:bg-green-700"
            >
              <FaDownload /> Download Template
            </button>

            <div className="flex justify-end gap-3">
              <button
                onClick={onClose}
                className="rounded-md bg-gray-500 px-4 py-2 text-sm text-white hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="rounded-md bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default CustomerUploadModal;
